"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconButton_module_css_1 = __importDefault(require("./IconButton.module.css"));
const clsx_1 = __importDefault(require("clsx"));
/**
 * Styled component used to render circular icon buttons
 */
function IconButton(props) {
    const { children, ...nativeProps } = props;
    return ((0, jsx_runtime_1.jsx)("button", { ...nativeProps, type: "button", className: (0, clsx_1.default)(IconButton_module_css_1.default.button, nativeProps.className), children: children }));
}
exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.js.map